import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard } from './core/guard/auth.guard'
import { BasicLayoutComponent } from './layout/basic-layout/basic-layout.component'
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component'
import { AccessDeniedComponent } from './modules/home/page/access-denied/access-denied.component'

const routes: Routes = [
  {
    path: 'auth',
    component: BasicLayoutComponent,
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    canLoad: [AuthGuard],
    component: ContentLayoutComponent,
    loadChildren: () => import('./feature-routing.module').then((m) => m.FeatureRoutingModule),
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
